import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './i18n/config'; // Initialize i18n
import App from './App';
import reportWebVitals from './reportWebVitals';

// ========== DISABLE CONSOLE FOR SECURITY ==========
// Disable all console methods to prevent information leakage
console.log = () => {};
console.debug = () => {};
console.info = () => {};
console.warn = () => {};
console.error = () => {};
console.table = () => {};
console.group = () => {};
console.groupEnd = () => {};
console.groupCollapsed = () => {};
console.time = () => {};
console.timeEnd = () => {};
console.trace = () => {};
console.dir = () => {};
console.dirxml = () => {};
console.assert = () => {};
console.count = () => {};
console.countReset = () => {};
console.clear = () => {};

// Handle unhandled promise rejections and errors to prevent console errors
window.addEventListener('unhandledrejection', (event) => {
  // Suppress all unhandled rejections for security
  event.preventDefault();
});

// Suppress browser extension errors (CSP violations, message channel errors)
window.addEventListener('error', (event) => {
  const errorMessage = event.message || String(event.error || '');
  // Suppress browser extension related errors
  if (errorMessage.includes('Content Security Policy') ||
      errorMessage.includes('message channel') ||
      errorMessage.includes('Extension context invalidated') ||
      errorMessage.includes('Receiving end does not exist') ||
      errorMessage.includes('chrome-extension://')) {
    event.preventDefault();
    return false;
  }
}, true);

// Suppress manifest icon warnings and React DevTools messages
if (typeof window !== 'undefined') {
  // Suppress manifest icon errors
  window.addEventListener('error', (event) => {
    const errorMessage = event.message || String(event.error || '');
    if (errorMessage.includes('manifest') || 
        errorMessage.includes('logo192.png') || 
        errorMessage.includes('logo512.png') ||
        errorMessage.includes('icon from the Manifest')) {
      event.preventDefault();
      return false;
    }
  }, true);
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
